import React from "react";
import { motion } from "framer-motion";
import { Box } from "@mui/material";
import theme from "../../styles/styleTheme";

const LoadingAnimation = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="60vh"
    >
      <motion.div
        style={{
          width: 20,
          height: 20,
          borderRadius: "50%",
          backgroundColor: theme.palette.primary.main,
          margin: "0 5px",
        }}
        animate={{
          y: [0, -20, 0],
        }}
        transition={{
          duration: 0.8,
          ease: "easeInOut",
          repeat: Infinity,
        }}
      />
      <motion.div
        style={{
          width: 20,
          height: 20,
          borderRadius: "50%",
          backgroundColor: theme.palette.primary.main,
          margin: "0 5px",
        }}
        animate={{
          y: [0, -20, 0],
        }}
        transition={{
          duration: 0.6,
          ease: "easeInOut",
          repeat: Infinity,
          delay: 0.4,
        }}
      />
      <motion.div
        style={{
          width: 20,
          height: 20,
          borderRadius: "50%",
          backgroundColor: theme.palette.primary.main,
          margin: "0 5px",
        }}
        animate={{
          y: [0, -20, 0],
        }}
        transition={{
          duration: 0.6,
          ease: "easeInOut",
          repeat: Infinity,
          delay: 0.6,
        }}
      />
    </Box>
  );
};

export default LoadingAnimation;
